import { PaywallError } from './PaywallError'

export class UnknownBlockError extends PaywallError {
  constructor(type: string) {
    super(`Unknown block ${type}`)
  }
}
